var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFavourite = function SvgFavourite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.693 2.107L6 2.67l.307-.562c.185-.337.492-.789.945-1.14.467-.36.989-.54 1.56-.54 1.598 0 2.838 1.303 2.838 3.108 0 .957-.38 1.777-1.098 2.644-.727.878-1.774 1.772-3.076 2.881l.227.267-.227-.267c-.44.375-.94.8-1.46 1.255a.025.025 0 0 1-.016.006.025.025 0 0 1-.016-.006c-.52-.454-1.02-.88-1.458-1.254h-.001c-1.302-1.11-2.35-2.004-3.077-2.882C.729 5.312.35 4.492.35 3.535.35 1.73 1.59.428 3.187.428c.572 0 1.094.18 1.56.54.454.35.761.802.946 1.14z",
    strokeWidth: 0.7
  })));
};
export default SvgFavourite;